import Vue from 'vue'
import { Module } from 'vuex'

type Forms = Record<string, Record<string, boolean>>

interface ValidationState {
  forms: Forms
}

const validationStore: Module<ValidationState, any> = {
  namespaced: true,

  state: (): ValidationState => ({
    forms: {},
  }),

  getters: {
    isFormValid: (state) => (formName: string): boolean => {
      const form = state.forms[formName]
      if (!form) return false
      const keys = Object.keys(form)
      if (keys.length === 0) return false
      return keys.every((k) => form[k] === true)
    },
  },

  mutations: {
    SET_FIELD(state, { formName, fieldKey, isValid }: { formName: string; fieldKey: string; isValid: boolean }) {
      if (!state.forms[formName]) {
        Vue.set(state.forms, formName, {})
      }
      Vue.set(state.forms[formName], fieldKey, isValid)
    },

    REMOVE_FIELD(state, { formName, fieldKey }: { formName: string; fieldKey: string }) {
      const form = state.forms[formName]
      if (!form) return
      Vue.delete(form, fieldKey)
      if (Object.keys(form).length === 0) {
        Vue.delete(state.forms, formName)
      }
    },

    RESET_FORM(state, formName: string) {
      Vue.delete(state.forms, formName)
    },
  },

  actions: {
    setField({ commit }, payload: { formName: string; fieldKey: string; isValid: boolean }) {
      commit('SET_FIELD', payload)
    },

    removeField({ commit }, payload: { formName: string; fieldKey: string }) {
      commit('REMOVE_FIELD', payload)
    },

    resetForm({ commit }, formName: string) {
      commit('RESET_FORM', formName)
    },
  },
}

export default validationStore
